module.exports = __webpack_public_path__ + "static/media/8.7a1cbea6.jpg";